<template>
	<transition name="fade">
		<div v-if="visible" class="loading-mask">
			<!-- Empty Node -->
			<div class="loading-spinner"></div>
		</div>
	</transition>
</template>

<script>
import { Loading } from 'irm-ui';

export default {
	name: 'LoadingMask',
	data() {
		return {
			visible: false,
			fullscreenLoading: null
		};
	},
	methods: {
		show() {
			this.visible = true;
			this.fullscreenLoading = Loading.service({
				lock: true,
				background: 'rgba(255, 255, 255)',
				customClass: 'custom-fullscreen-loading'
			});
		},
		hide() {
			this.visible = false;
			this.fullscreenLoading?.close();
			this.fullscreenLoading = null;
		}
	}
};
</script>

<style lang="less">
.loading-mask {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	z-index: 100;
}
.custom-fullscreen-loading {
	&.el-loading-mask {
		.el-loading-spinner .path {
			stroke: #6b7280; // 中性色
		}
	}
}
</style>
